import { dateFNS } from '@gogame/intl-ts';
import { rangePresets, toDate } from '@gogame/intl-ts';
import { object, number, array, string, collection } from '@gogame/schemas';

import {
  FILTER_DATE,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_PLATFORMS,
  FILTER_TRAFFIC_TYPE,
  FILTER_TIME_ZONE,
  FILTER_CLUSTERS,
  FILTER_OWNERS,
  FILTER_AFFILIATES,
  FILTER_COUNTRIES,
  FILTER_MANAGERS,
  PERIOD_PRESETS,
} from '../constants';

export const EMPTY_FILTERS = [
  {
    [FILTER_DATE]: rangePresets.YESTERDAY.value,
    [FILTER_TIME_ZONE]: 'UTC',
  },
  {
    [FILTER_DATE]: rangePresets.TODAY.value,
    [FILTER_TIME_ZONE]: 'UTC',
  },
];

export const filtersSchema = object({
  [FILTER_DATE]: array(string()).constants(PERIOD_PRESETS),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_NETWORKS]: array(number()),
  [FILTER_PLATFORMS]: array(number()),
  [FILTER_TRAFFIC_TYPE]: number(),
  [FILTER_TIME_ZONE]: string(),
  [FILTER_CLUSTERS]: array(number()),
  [FILTER_OWNERS]: array(number()),
  [FILTER_AFFILIATES]: array(number()),
  [FILTER_COUNTRIES]: array(number()),
  [FILTER_MANAGERS]: array(number()),
});

export const baseCompareSchema = object({
  [FILTER_DATE]: array(string()).transform((value) => {
    const diff =
      Math.abs(
        dateFNS.differenceInDays(...value.map((dateStr) => toDate(dateStr)))
      ) + 1;
    return value.map((dateStr) =>
      dateFNS.subDays(toDate(dateStr), diff).toISOString()
    );
  }),
  [FILTER_TIME_ZONE]: string(),
});

export const compareSchema = object({
  [FILTER_DATE]: array(string()),
  [FILTER_TIME_ZONE]: string(),
});

export const filtersCollectionSchema =
  collection(filtersSchema).default(EMPTY_FILTERS);
